module.exports = __webpack_public_path__ + "img/register-v2.16e15a40.svg";